(() => {
  'use strict';

  // Resize only Shopify-hosted files; preserve version and other URL parameters.
  function categoryImageUrl(src, width) {
    try {
      const url = new URL(src, window.location.origin);
      if ((url.hostname === window.location.hostname && url.pathname.startsWith('/cdn/shop/')) ||
          (url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/'))) {
        url.searchParams.set('width', String(width));
        return url.href;
      }
    } catch (_) {}
    return src;
  }
  const cache = new Map();
  const normalize = value => (value || '').replace(/&amp;/g,'&').replace(/\s+/g,' ').trim().toLowerCase();
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const clean = value => (value || '').replace(/\s+/g,' ').trim();
  const truncate = (value,max=170) => { value=clean(value); return value.length<=max ? value : value.slice(0,max-1).replace(/[\s,;:.!?-]+$/,'')+'…'; };
  async function resolve(title){
    const key=normalize(title); if(!key) return null; if(cache.has(key)) return cache.get(key);
    const promise=(async()=>{
      const searchUrl=root()+'search/suggest.json?q='+encodeURIComponent(title)+'&resources[type]=collection&resources[limit]=10';
      const res=await fetch(searchUrl,{headers:{Accept:'application/json'}}); if(!res.ok) return null;
      const data=await res.json(); const list=data?.resources?.results?.collections || [];
      const item=list.find(x=>normalize(x.title)===key) || (list.length===1?list[0]:null); if(!item?.url) return null;
      const out={title:item.title||title,url:item.url,image:'',description:''};
      try{
        const page=await fetch(item.url,{headers:{Accept:'text/html'}}); if(page.ok){
          const html=await page.text(); const doc=new DOMParser().parseFromString(html,'text/html');
          out.image=doc.querySelector('meta[property="og:image:secure_url"]')?.content || doc.querySelector('meta[property="og:image"]')?.content || '';
          const desc=doc.querySelector('.hdt-collection-description, .hdt-collection-description-short, [data-collection-description]')?.textContent || doc.querySelector('meta[name="description"]')?.content || doc.querySelector('meta[property="og:description"]')?.content || '';
          out.description=truncate(desc);
        }
      }catch(_){}
      return out;
    })().catch(()=>null); cache.set(key,promise); return promise;
  }
  function enhance(scope){
    scope.querySelectorAll('[data-ewa-resolve-card]:not([data-ewa-v10-ready])').forEach(card=>{
      card.dataset.ewaV10Ready='1'; if(card.dataset.ewaResolved==='1') return;
      const title=card.dataset.ewaCollectionTitle; if(!title) return;
      resolve(title).then(data=>{
        if(!data) return; card.href=data.url; card.dataset.ewaResolved='1';
        const image=card.querySelector('[data-ewa-resolve-image]'); const empty=card.querySelector('[data-ewa-empty]');
        if(image && data.image){ image.sizes=image.dataset.ewaImageSizes || '100vw'; if(categoryImageUrl(data.image,900)!==data.image) image.srcset=[180,240,360,480,640,900,1200,1600].map(w=>categoryImageUrl(data.image,w)+' '+w+'w').join(', '); image.src=categoryImageUrl(data.image,900); image.style.opacity='1'; if(empty) empty.remove(); }
        const desc=card.querySelector('[data-ewa-resolve-description]'); if(desc && !clean(desc.textContent) && data.description) desc.textContent=data.description;
      });
      card.addEventListener('click',e=>{ if(card.dataset.ewaResolved==='1') return; e.preventDefault(); resolve(title).then(data=>{ if(data?.url) window.location.assign(data.url); }); });
    });
  }
  function init(){ document.querySelectorAll('[data-ewa-section-resolver]').forEach(enhance); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:block:select',init);
})();
